import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            视频专区
          </h2>
          <p className="text-sm text-foreground-500">高清吃瓜视频，精彩内容一网打尽</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          <div className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden cursor-pointer">
            <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20still%20showing%20a%20spotlight%20on%20an%20empty%20stage%20with%20warm%20golden%20lighting%2C%20theatrical%20atmosphere%2C%20dark%20background%2C%20editorial%20style&width=800&height=500&seq=media-01&orientation=landscape"
                alt="黑料吃瓜在线视频 - 顶流塌房全记录"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-foreground-900/20 flex items-center justify-center">
                <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                  <i className="ri-play-fill text-lg" />
                </div>
              </div>
              <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-foreground-900/70 text-background-50 text-[10px] font-medium whitespace-nowrap">15:28</span>
            </div>
            <div className="p-3">
              <h3 className="text-xs font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1.5">顶流塌房全记录：从巅峰到谷底</h3>
              <div className="flex items-center justify-between text-[11px] text-foreground-400">
                <span>258万次播放</span>
                <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap">深度解析</span>
              </div>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden cursor-pointer">
            <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20studio%20setup%20with%20ring%20light%20and%20smartphone%20on%20tripod%2C%20live%20streaming%20equipment%2C%20warm%20ambient%20lighting%2C%20clean%20minimal%20background%2C%20product%20photography%20style&width=800&height=500&seq=media-02&orientation=landscape"
                alt="黑料吃瓜在线视频 - 揭秘网红直播间的那些套路"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-foreground-900/20 flex items-center justify-center">
                <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                  <i className="ri-play-fill text-lg" />
                </div>
              </div>
              <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-foreground-900/70 text-background-50 text-[10px] font-medium whitespace-nowrap">12:45</span>
            </div>
            <div className="p-3">
              <h3 className="text-xs font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1.5">揭秘网红直播间的那些套路</h3>
              <div className="flex items-center justify-between text-[11px] text-foreground-400">
                <span>186万次播放</span>
                <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap">行业揭秘</span>
              </div>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden cursor-pointer">
            <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=An%20editorial%20composition%20showing%20multiple%20TV%20screens%20displaying%20colorful%20entertainment%20content%2C%20warm%20lighting%2C%20modern%20media%20room%20aesthetic%2C%20clean%20dark%20background&width=800&height=500&seq=media-03&orientation=landscape"
                alt="黑料吃瓜在线视频 - 娱乐圈最尴尬的十大名场面"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-foreground-900/20 flex items-center justify-center">
                <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                  <i className="ri-play-fill text-lg" />
                </div>
              </div>
              <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-foreground-900/70 text-background-50 text-[10px] font-medium whitespace-nowrap">08:32</span>
            </div>
            <div className="p-3">
              <h3 className="text-xs font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1.5">娱乐圈最尴尬的十大名场面</h3>
              <div className="flex items-center justify-between text-[11px] text-foreground-400">
                <span>312万次播放</span>
                <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap">趣味盘点</span>
              </div>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden cursor-pointer">
            <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20conceptual%20editorial%20image%20showing%20a%20calendar%20with%20dramatic%20lighting%2C%20representing%20year-end%20review%2C%20warm%20golden%20and%20amber%20tones%2C%20dark%20sophisticated%20background&width=800&height=500&seq=media-04&orientation=landscape"
                alt="黑料吃瓜在线视频 - 2026年最大反转"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-foreground-900/20 flex items-center justify-center">
                <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                  <i className="ri-play-fill text-lg" />
                </div>
              </div>
              <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-foreground-900/70 text-background-50 text-[10px] font-medium whitespace-nowrap">10:15</span>
            </div>
            <div className="p-3">
              <h3 className="text-xs font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1.5">2026年最大反转：被打脸的预言</h3>
              <div className="flex items-center justify-between text-[11px] text-foreground-400">
                <span>145万次播放</span>
                <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap">年度回顾</span>
              </div>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden cursor-pointer">
            <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20editorial%20photography%20showing%20TV%20studio%20equipment%20and%20cameras%20with%20warm%20lighting%2C%20backstage%20atmosphere%2C%20golden%20ambient%20light%2C%20clean%20composition&width=800&height=500&seq=media-05&orientation=landscape"
                alt="黑料吃瓜在线视频 - 明星综艺后台花絮合集"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-foreground-900/20 flex items-center justify-center">
                <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                  <i className="ri-play-fill text-lg" />
                </div>
              </div>
              <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-foreground-900/70 text-background-50 text-[10px] font-medium whitespace-nowrap">06:58</span>
            </div>
            <div className="p-3">
              <h3 className="text-xs font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1.5">明星综艺后台花絮合集</h3>
              <div className="flex items-center justify-between text-[11px] text-foreground-400">
                <span>98万次播放</span>
                <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap">独家花絮</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}